const initialState = {
    usersPermissions:[],
    userLists: [],
    userSingleList: [],
    userStatus: [],
    changedUserStatus : [],
    loadingUser: false,
    errorsUser: {},
    userFeeStructureItems: [],
    userFeeStructureLists: [],
    userFeeStructureSingleList: [],
    userFeeStructureCount: 0,
    userFeeStructurePermissions: [],
    changedUserFeeStructure: []
}

const  userReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USERLIST_PENDING":
        case "GET_USER_FEE_STRUCTURE_LIST_PENDING":
        case "ADD_USER_PENDING":
        case "UPDATE_USER_PENDING":
        case "DELETE_USER_PENDING":
        case "RESEND_EMAIL_CONFIRMATION_PENDING":
        case "UPDATE_USER_STATUS_PENDING":
        case "LOGOUT_USER_DEVICE_PENDING":
        case "GET_USERLISTBYID_PENDING":
        case "ADD_USER_FEE_STRUCTURE_PENDING":
        case "DELETE_USER_FEE_STRUCTURE_PENDING":
        case "UPDATE_USER_FEE_STRUCTURE_PENDING":
            return { ...state, loadingUser: true };

        case "GET_USERLIST_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                userLists: action.payload,
                userCount: action.userCount,
                usersPermissions:action.permissions,
            };

        case "GET_USER_FEE_STRUCTURE_LIST_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                userFeeStructureLists: action.payload,
                userFeeStructureCount: action.userFeeStructureCount,
                userFeeStructurePermissions: action.permissions,
            };

        case "ADD_USER_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };

        case "UPDATE_USER_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };
        
        case "UPDATE_USER_STATUS_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };

        case "ADD_USER_FEE_STRUCTURE_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserFeeStructure: action.payload
            };

        case "UPDATE_USER_FEE_STRUCTURE_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserFeeStructure: action.payload
            };

        case "DELETE_USER_FEE_STRUCTURE_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserFeeStructure: action.payload
            };

        case "RESEND_EMAIL_CONFIRMATION_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };

        case "LOGOUT_USER_DEVICE_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };

        case "GET_USERLISTBYID_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                userSingleList: action.payload
            };

        case "GET_USER_FEE_STRUCTURE_BY_ID_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                userFeeStructureSingleList: action.payload
            };


        case "DELETE_USER_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload
            };


        case "RESET_DELETE_USER_STATUS":
            return {
                ...state,
                loadingUser: false,
                userSingleList:[],
                changedUserStatus: [],
                errorsUser:{}
            };

        case "RESET_DELETE_USER_FEE_STRUCTURE_STATUS":
            return {
                ...state,
                loadingUser: false,
                changedUserFeeStructure: [],
                errorsUser: {}
            };

        case "GET_USERLIST_REJECTED":
        case "GET_USER_FEE_STRUCTURE_LIST_REJECTED":
        case "GET_USER_FEE_STRUCTURE_BY_ID_REJECTED":
        case "ADD_USER_REJECTED":
        case "UPDATE_USER_REJECTED":
        case "ADD_USER_FEE_STRUCTURE_REJECTED":
        case "DELETE_USER_FEE_STRUCTURE_REJECTED":
        case "DELETE_USER_REJECTED":
        case "RESEND_EMAIL_CONFIRMATION_REJECTED":
        case "GET_USERLISTBYID_REJECTED":
        case "LOGOUT_USER_DEVICE_REJECTED":
        case "UPDATE_USER_FEE_STRUCTURE_REJECTED":
        case "UPDATE_USER_STATUS_REJECTED" :
            return {
                ...state,
                loadingUser: false,
                errorsUser: action.payload
            };

        default:
            return state;
    }
}

export default userReducer;